import React from 'react';

interface Props {
  text: string;
  onClick: () => void;
  className?: string;
}

// tslint:disable-next-line:function-name
export default function Link({
  text,
  onClick,
  className,
}: Props) {
  return (
    <a
      className={className || 'mt-0 pb-0'}
      href="#"
      onClick={(event) => {
        // this + href="#" is a hack to make this look like a link
        // as the Cimpress UX <Link> has rectangular border like a button
        event.preventDefault();
        onClick();
      }}
    >
      {text}
    </a>
  );
}
